<template>
  <div>
    <b-sidebar id="sidebar-products" title="Conteúdo" shadow>
      <div>
        <SidebarProducts />
      </div>
    </b-sidebar>
    <b-container class="py-4">
      <b-row>
        <b-col sm="12" lg="3" xl="3" class="d-none d-lg-block">
          <SidebarProducts style="top: 100px" />
        </b-col>
        <b-col>
          <b-container>
            <router-view></router-view>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
    <div class="fab-container">
      <b-button
        variant="warning"
        v-b-toggle.sidebar-products
        class="d-lg-none"
        size="lg"
        style="border-radius: 50%; height: 100%; width: 100%;"
      >
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          class="bi bi-list"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          />
        </svg>
      </b-button>
    </div>
  </div>
</template>

<script>
import SidebarProducts from "@/components/products/SidebarProducts";

export default {
  name: "Products",
  components: {
    SidebarProducts,
  },
};
</script>

<style>
.b-sidebar {
  top: 100px;
}

.fab-container {
  position: fixed;
  height: 50px;
  width: 50px;
  right: 1rem;
  bottom: 1rem;
  z-index: 1;
}
</style>
